<template>
  <div>
    <h3 class="pb-2">{{$i18n.t('ObservationPage.guidingQuestions')}}</h3>
    <v-expansion-panels accordion="accordion" v-model="expandModel">
      <v-expansion-panel v-for="(item,i) in information" :key="i">
        <v-expansion-panel-header>{{item.name}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list>
            <v-list-item v-for="(text,i) in item.paragraphs" :key="i">

              <v-list-item-content>
                <p>{{text.text}}</p>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon @click.stop="insertText(text.text)">
                  <v-icon color="lighten-1">mdi-clipboard-arrow-left-outline</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>

  import { EventBus, EVENTS } from '../libs/eventBus';

  const copyToClipboard = (str) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export default {
  name: 'ObservationInformation',
  props: ['information'],
  data: () => ({
    expandModel: 0,
  }),
  methods: {
    insertText(text) {
      EventBus.$emit(EVENTS.MCE_INSERT_TEXT, text);
    },
    copyText(text) {
      copyToClipboard(text);
      this.showTooltip = true;
    },
  },
};
</script>

<style scoped>

</style>
